/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Title1Inputs */

const zh_systemsettings_title1 = /** @type {(inputs: Systemsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统设置`)
};

const en_systemsettings_title1 = /** @type {(inputs: Systemsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Settings`)
};

const es_systemsettings_title1 = /** @type {(inputs: Systemsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del sistema`)
};

/**
* | output |
* | --- |
* | "System Settings" |
*
* @param {Systemsettings_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_title1 = /** @type {((inputs?: Systemsettings_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_title1(inputs)
	if (locale === "en") return en_systemsettings_title1(inputs)
	return es_systemsettings_title1(inputs)
});
export { systemsettings_title1 as "systemSettings_title" }